import { IOrganizer } from '@features/organizer/model/types';
import { concatArray } from '@shared/lib';

// Отдельного метода за данными текущего пользователя нет, поэтому фамилию и имя ищем
// среди организаторов мероприятия — этот список уже загружен на вкладке.
export const getOrganizerFullName = (organizers: IOrganizer[] | undefined, userId: number | undefined) => {
  if (!organizers || !userId) return undefined;

  const organizer = organizers.find(({ id }) => id === userId);

  if (!organizer) return undefined;

  return concatArray([organizer.lastName, organizer.firstName]) || undefined;
};
